import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchCollectors, triggerSync } from '@/api/collectors';

export function useCollectors() {
  return useQuery({
    queryKey: ['collectors'],
    queryFn: fetchCollectors,
    staleTime: 30 * 1000,
    refetchInterval: 30 * 1000,
  });
}

export function useTriggerSync() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (collectorName: string) => triggerSync(collectorName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['collectors'] });
    },
  });
}
